// CustomPagination.js
import React from "react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { HiUsers } from "react-icons/hi";
import "./CustomPagination.css";

const CustomPagination = ({ totalPages, currentPage, paginate, totalItems }) => {
  if (totalPages <= 0) return null;

  return (
    <div className="pagination-container">
      <div className="total-data-badge">
        <HiUsers size={18} />
        Total Data: <span>{totalItems || 0}</span>
      </div>

      <div className="premium-pagination">
        <button
          className="pagination-btn nav-btn"
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <MdChevronLeft size={20} />
          <span>Previous</span>
        </button>

        <div className="pagination-btn page-active">
          Page <span>{currentPage}</span> / {totalPages}
        </div>

        <button
          className="pagination-btn nav-btn"
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <span>Next</span>
          <MdChevronRight size={20} />
        </button>
      </div>
    </div>
  );
};

export default CustomPagination;
